"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PercentFieldLogic = void 0;
const types_1 = require("@smartsuite/types");
const clipboard_1 = require("../../utils/clipboard");
const google_sheet_1 = require("../../utils/google-sheet");
const intl_1 = require("../../locale/intl");
const percent_fieldtype_1 = require("../../safe-field-value/numder-fields/percent-field/percent.fieldtype");
const texts_1 = require("../../texts");
const number_1 = require("../../utils/number");
const base_number_fieldtype_1 = require("../base-fields/base-number.fieldtype");
const percent_1 = require("../../formatters/percent");
class PercentFieldLogic extends base_number_fieldtype_1.BaseNumberFieldLogic {
    constructor() {
        super(...arguments);
        this.name = "percentfield";
        this.label = (0, intl_1.$t)(texts_1.percentFieldText.percent);
        this.icon = "percent";
        this.iconColor = "#4ECCFD";
        this.placeholder = (0, intl_1.$t)(texts_1.percentFieldText.enter_number_here);
        this.searchSynonyms = ["%"];
        this.isNumber = true;
        this.fieldValueGetter = new percent_fieldtype_1.PercentFieldValueGetter();
        this.clipboardPasteRules = {
            numberfield: clipboard_1.clipboardNumberToNumber,
            currencyfield: clipboard_1.clipboardNumberToNumber,
            percentfield: clipboard_1.clipboardNumberToNumber,
            ratingfield: clipboard_1.clipboardNumberToNumber,
            autonumberfield: clipboard_1.clipboardNumberToNumber,
            rollupfield: clipboard_1.clipboardTextToNumber,
            votefield: clipboard_1.clipboardTextToNumber,
            countfield: clipboard_1.clipboardCountToNumber,
            numbersliderfield: clipboard_1.clipboardNumberToNumber,
            percentcompletefield: clipboard_1.clipboardNumberToNumber,
            unknownfield: clipboard_1.clipboardTextToNumber,
            textfield: clipboard_1.clipboardTextToNumber,
            recordtitlefield: clipboard_1.clipboardTextToNumber,
            richtextareafield: clipboard_1.clipboardTextToNumber,
            textareafield: clipboard_1.clipboardTextToNumber,
        };
    }
    isValueEmpty(fieldValue) {
        return fieldValue === null || fieldValue === undefined;
    }
    valueToString(fieldValue, field, userPreferences) {
        var _a;
        return (0, percent_1.convertPercentFieldValueToString)({
            value: fieldValue,
            locale: (_a = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.locale) === null || _a === void 0 ? void 0 : _a.value,
            params: field.params,
        });
    }
    valueToGoogleSheet(fieldValue, _field, _userPreferences) {
        if (this.isValueEmpty(fieldValue))
            return (0, google_sheet_1.makeRowDataValues)(null, "numberValue");
        const value = Number(fieldValue);
        return (0, google_sheet_1.makeRowDataValues)(value, "numberValue");
    }
    valueToExcelExport(fieldValue, field, userPreferences, _record) {
        const value = !fieldValue || isNaN(fieldValue) ? "" : String(fieldValue / 100);
        return {
            t: value ? "n" : "t",
            v: value,
        };
    }
    getInitialFieldValue(startValue, field, userPreferences) {
        return this.validateValue(field, startValue, true, userPreferences)
            ? startValue
            : this.getEmptyValue();
    }
    getGridColumnSettings(field) {
        return {
            ...super.getGridColumnSettings(field),
            contentAlignment: "right",
        };
    }
    getLinkedRecordFieldSmartWidth(_field) {
        return {
            defaultWidht: 90,
            minWidth: 45,
        };
    }
    /**
     * Checks if the values are equal.
     */
    isValueEqual(fieldValue1, fieldValue2, _field, _userPreferences) {
        return fieldValue1 === fieldValue2;
    }
    prepareValueForClipboard(fieldValue, srcField, userPreferences) {
        var _a;
        return {
            text: (0, percent_1.convertPercentFieldValueToString)({
                value: fieldValue,
                locale: (_a = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.locale) === null || _a === void 0 ? void 0 : _a.value,
                params: {
                    ...srcField.params,
                    precision: (0, number_1.getDecimalPlacesNum)(fieldValue),
                },
            }),
            rawValue: fieldValue,
        };
    }
    filterToRecordValue(filterValue, comparison, field) {
        if (comparison !== "is_equal_to" || !(0, number_1.isNumeric)(filterValue)) {
            throw new types_1.FilterToRecordValueConversionError(field, filterValue, comparison);
        }
        const value = Number(filterValue);
        if (!field.params.allow_negative && value < 0) {
            throw new types_1.FilterToRecordValueConversionError(field, filterValue, comparison);
        }
        return value;
    }
    getDefaultValue(field, userPreferences) {
        const defaultVale = super.getDefaultValue(field, userPreferences);
        if (this.isValueEmpty(defaultVale)) {
            return defaultVale;
        }
        return Number(field.params.default_value);
    }
    metricWidgetValueToString(fieldValue, field, userPreferences) {
        const numberValue = Number(fieldValue);
        return this.valueToString(numberValue, field, userPreferences);
    }
}
exports.PercentFieldLogic = PercentFieldLogic;
